import React, { useEffect, useState } from 'react';
import {
  Radio, Space, Tabs, Grid,
} from 'antd';
import PropTypes from 'prop-types';
import { EditOutlined } from '@ant-design/icons';
import DatosGenerales from './DatosGenerales/index';
import Requisitos from './Requisitos/index';

const TabsVisitas = ({ selectedRow, callbackInformation }) => {
  const screens = Grid.useBreakpoint();

  callbackInformation(selectedRow);

  const items = [
    {
      label: (
        <span>
          <EditOutlined />
          INFORMACIÓN BÁSICA I
        </span>
      ),
      key: '1',
      children: <DatosGenerales
        selectedRow={selectedRow}
        callbackInformation={callbackInformation}
      />,
    },
    {
      label: (
        <span>
          <EditOutlined />
          INFORMACIÓN BÁSICA II
        </span>
      ),
      key: '2',
      children: <Requisitos
        selectedRow={selectedRow}
        callbackInformation={callbackInformation}
      />,
    },
    {
      label: (
        <span>
          <EditOutlined />
          DERECHOS Y OBLIGACIONES
        </span>
      ),
      key: '3',
      children: 'DERECHOS Y OBLIGACIONES',
    },
    {
      label: (
        <span>
          <EditOutlined />
          ESTADÍSTICAS
        </span>
      ),
      key: '4',
      children: 'ESTADÍSTICAS',
    },
    // {
    //   label: 'ESTADÍSTICAS',
    //   key: '5',
    //   children: 'Contentenido de aplica',
    // },
    // {
    //   label: 'Derechos y Obligaciones',
    //   key: '6',
    //   children: 'Content of derechos y obligaciones',
    // },
    // {
    //   label: 'Sanciones',
    //   key: '7',
    //   children: 'Content de Sanciones',
    // },
    // {
    //   label: 'Inspectores',
    //   key: '8',
    //   children: 'Contentenido de Inspectores',
    // },
    // {
    //   label: 'Autoridad Responsable',
    //   key: '9',
    //   children: 'Contentenido de Autoridad Responsable',
    // },
    // {
    //   label: 'Estadisticas',
    //   key: '10',
    //   children: 'Contentiendo de Estadisticas',
    // },
  ];

  return (
    <Tabs
      tabPosition={screens.md ? 'left' : 'top'}
      items={items}
    />
  );
};

TabsVisitas.propTypes = {
  selectedRow: PropTypes.shape({}).isRequired,
  callbackInformation: PropTypes.func.isRequired,
};

export default TabsVisitas;
